export class Group {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.portalID = json && json.portal_id || null;
        this.groupName = json && json.group_name || null;
        this.groupDescription = json && json.group_description || null;
        this.groupOwnerID = json && json.groupOwnerID || null;
        this.inactive = json && json.inactive || false;
        this.groupChatSID = json && json.group_chat_sid || null;
        this.groupMemberCount = json && json.group_member_count || 0;
        this.groupChatInactive = json && json.group_chat_inactive || false;
        this.childPortalID = json && json.child_portal_id || null;
        this.childPortalName = json && json.child_portal_name || null;
        this.childPortalLogo = json && json.child_portal_logo || null;
        this.isStaff = json && json.is_staff || false;
        this.isPlayerGroup = json && json.is_player_group || false;
        this.isNonPlayerGroup = json && json.is_non_player_group || false;

        this.userInGroup = false;
        this.groupSelected = false;
    }

    id: number;
    portalID: number;
    groupName: string;
    groupDescription: string;
    groupOwnerID: number;
    inactive: boolean;
    groupChatSID: string;
    groupMemberCount: number;
    groupChatInactive: boolean;
    childPortalID: number;
    childPortalName: string;
    childPortalLogo: string;
    isStaff: boolean;
    isPlayerGroup: boolean;
    isNonPlayerGroup: boolean;

    userInGroup: boolean;
    groupSelected: boolean;

    toJSON() {
        return {
            id: this.id,
            portal_id: this.portalID,
            group_name: this.groupName,
            group_description: this.groupDescription,
            group_owner_id: this.groupOwnerID,
            inactive: this.inactive,
            group_chat_sid: this.groupChatSID,
            group_member_count: this.groupMemberCount,
            group_chat_inactive: this.groupChatInactive,
            child_portal_id: this.childPortalID,
            child_portal_logo: this.childPortalLogo,

            group_selected:this.groupSelected
        }
    }
}
